<div class="list-wrapper {{type}}">
  <div class="title">{{drugObjects.title}}</div>
  <section class="content">
    <span *ngIf="drugObjects.list.length === 0">No available data</span>
    <div class="list Auto_Drag_List" *ngIf="drugObjects.list.length > 0" [ngClass]="{'disabled-state':!(drugObjects.selectable && caseStatus)}">
      <p-checkbox
        *ngFor="let drugObject of drugObjects.list;trackBy:drugObject?.name"
        genTooltip
        checkboxIcon="icon__Checkmark1"
        [tooltipPosition]="'bottom'"
        [tooltipShow]="type !== 'within'"
        [tooltipText]="type === 'outside' ? 'Indication: ' + drugObject.diseaseInOtherIndications : 'Status: '+drugObject.fdaStatusWithinIndication"
        class="drug-item Auto_Drag_CheckList"
        [ngClass]="{'disabled-status':!(drugObjects.selectable && caseStatus)}"
        [disabled]="!(drugObjects.selectable && caseStatus)"
        name="selectedDrugs"
        value="{{getIdentifier(drugObject)}}"
        label="{{drugObject.displayName}}"
        [ngModel]="selectedDrugs|async"
        (ngModelChange)="onChange(drugObject, $event)"></p-checkbox>
    </div>
  </section>
</div>
